import React from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/Button';
import { Link } from 'react-router-dom';
const CATEGORIES = [{
  name: 'Accessories',
  link: '/23m8/accessories.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/Category%20Images/Accessories2.JPG&opt=w3'
}, {
  name: 'Apparel',
  link: '/23m8/apparel.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/Category%20Images/apparel.JPG&opt=w3'
}, {
  name: 'Bathrooms',
  link: '/23m8/bathrooms.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/New_Temp/Bathrooms/Bathroom5.jpg&opt=w3'
}, {
  name: 'Bedrooms',
  link: '/23m8/bedrooms.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/New_Temp/Bedrooms/Bedrooms1.JPG&opt=w3'
}, {
  name: 'Before & After',
  link: '/23m8/before-after.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/New_Temp/Before%20%26%20After/140508121027.jpg&opt=w3'
}, {
  name: 'Commercial',
  link: '/23m8/commercial.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/P1013937.jpg&opt=w3'
}, {
  name: 'Dining Rooms',
  link: '/23m8/dining-rooms.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/P1014171.jpg&opt=w3'
}, {
  name: 'Furniture',
  link: '/23m8/furniture.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/New_Temp/Bedrooms/IMG_9817.JPG&opt=w3'
}, {
  name: 'Kitchens',
  link: '/23m8/kitchens.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/P1014168.jpg&opt=w3'
}, {
  name: 'Lighting',
  link: '/23m8/lighting.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/lighting%20and%20bathroom.jpg&opt=w3'
}, {
  name: 'Living Rooms',
  link: '/23m8/living-rooms.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/P1014111.jpg&opt=w3'
}, {
  name: 'Lower Levels',
  link: '/23m8/lower-levels.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/lower%20level.jpg&opt=w3'
}, {
  name: 'Seminars and Events',
  link: '/23m8/seminars-and-events.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/IMG_3233.jpg&opt=w3'
}, {
  name: 'Staging',
  link: '/23m8/staging.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/Blog%20Images/clutter%20free.jpg&opt=w3'
}, {
  name: 'Window Treatments',
  link: '/23m8/window-treatments.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/P1013895.jpg&opt=w3'
}];
export function Portfolio() {
  return <Layout data-id="element-374">
      {/* Hero Section */}
      <section className="relative py-32 px-4 bg-gradient-to-br from-taupe-200/50 to-cream-100 border-b border-taupe-200" data-id="element-375">
        <div className="max-w-4xl mx-auto text-center" data-id="element-376">
          <span className="text-sage-600 uppercase tracking-[0.2em] text-xs font-semibold mb-6 block" data-id="element-377">
            Our Work
          </span>
          <h1 className="text-4xl md:text-6xl font-serif text-charcoal-900 mb-6 leading-tight" data-id="element-378">
            A Portfolio of
            <br data-id="element-379" />
            <span className="italic" data-id="element-380">Timeless Spaces</span>
          </h1>
          <p className="text-xl text-charcoal-900/70 leading-relaxed max-w-2xl mx-auto" data-id="element-381">
            Every project tells a story. Explore our collection of completed
            designs, curated retail offerings, and transformative staging work.
          </p>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-20 px-4 bg-white border-b border-taupe-200" data-id="element-382">
        <div className="max-w-4xl mx-auto text-center" data-id="element-383">
          <h2 className="text-2xl md:text-3xl font-serif text-charcoal-900 mb-6" data-id="element-384">
            Real Projects, Real Results
          </h2>
          <p className="text-lg text-charcoal-900/70 leading-relaxed mb-6" data-id="element-385">
            This portfolio represents over two decades of design work throughout
            Michigan. From complete home renovations to carefully staged
            properties, from custom window treatments to curated retail
            collections—each image reflects our commitment to quality, attention
            to detail, and timeless aesthetic.
          </p>
          <p className="text-lg text-charcoal-900/70 leading-relaxed" data-id="element-386">
            Browse by category to find inspiration for your own project, or
            contact us to discuss how we can bring your vision to life.
          </p>
        </div>
      </section>

      {/* Category Grid */}
      <section className="py-24 px-4 bg-cream-100" data-id="element-387">
        <div className="max-w-7xl mx-auto" data-id="element-388">
          <div className="text-center mb-16" data-id="element-389">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-4" data-id="element-390">
              Browse by Category
            </h2>
            <p className="text-lg text-charcoal-900/60" data-id="element-391">
              Select a category to view our work in that area
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-id="element-392">
            {CATEGORIES.map(category => <a key={category.name} href={category.link} className="group relative aspect-[3/4] bg-white border border-taupe-200 overflow-hidden hover:shadow-soft transition-all duration-300" data-id="element-393">
                {/* Category Image */}
                <img src={category.image} alt={category.name} className="absolute inset-0 w-full h-full object-cover" data-id="element-394" />

                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal-900/90 via-charcoal-900/30 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300" data-id="element-395" />

                {/* Category Name */}
                <div className="absolute inset-0 flex items-end p-6" data-id="element-396">
                  <div className="transform translate-y-1 group-hover:translate-y-0 transition-transform duration-300" data-id="element-397">
                    <h3 className="text-white font-serif text-lg md:text-xl leading-tight group-hover:text-sage-200 transition-colors" data-id="element-398">
                      {category.name}
                    </h3>
                  </div>
                </div>
              </a>)}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 px-4 bg-white" data-id="element-399">
        <div className="max-w-4xl mx-auto text-center" data-id="element-400">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-6" data-id="element-401">
            Ready to Start Your Project?
          </h2>
          <p className="text-xl text-charcoal-900/70 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-402">
            Let's discuss how we can transform your space with the same care and
            attention you see in our portfolio.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-403">
            <Link to="/contact" data-id="element-404">
              <Button size="lg" className="min-w-[200px]" data-id="element-405">
                Schedule Consultation
              </Button>
            </Link>
            <Link to="/store-info" data-id="element-406">
              <Button variant="outline" size="lg" className="min-w-[200px]" data-id="element-407">
                Visit Our Showroom
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </Layout>;
}